import { CARREFOURGENETIQUES_PAGE_KEY } from 'src/pages/pagesKeys';

import GenericItemPage, { DOM_ID } from 'src/pages/generic-item-page/GenericItemPage';
import CarrefourGenetiqueContent from './CarrefourGenetiqueContent';

export default {
  key: CARREFOURGENETIQUES_PAGE_KEY,
  path: '/carrefourgenetique',
  elId: DOM_ID,
  className: 'carrefour-genetique-page',
  component: GenericItemPage,
  childComponent: CarrefourGenetiqueContent,
  relatedDataToFetch: ['exhibitor'],
};
